import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  inputLabel: {
    fontSize: "12px",
  },
  input: {
    borderRadius: theme.spacing(1),
  },
  storesIconContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-evenly",
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(1),
    cursor: "pointer",
  },
}));

export default useStyles;
